import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../app/directives/shared.module'
import { c_card_event_viewer_time_line_summary_input_area_component } from './c_card_event_viewer_time_line_summary_input_area.component';

@NgModule({
  imports: [ CommonModule, FormsModule, SharedModule ],
  declarations: [ 
    c_card_event_viewer_time_line_summary_input_area_component,
  ],
  exports: [c_card_event_viewer_time_line_summary_input_area_component],
})
export class c_card_event_viewer_time_line_summary_input_area_module { }
